import VIRTUAL_KEYBOARD_ACTIONS from '../types/enums/virtualKeyboardActions';
import { AutoComplete } from '@shared/types/interfaces/search';

class JumpPosition {
  LEFT?: number;
  RIGHT?: number;
  UP?: number;
  DOWN?: number;

  constructor(
    LEFT: number | undefined = undefined,
    RIGHT: number | undefined = undefined,
    UP: number | undefined = undefined,
    DOWN: number | undefined = undefined
  ) {
    this.LEFT = LEFT;
    this.RIGHT = RIGHT;
    this.UP = UP;
    this.DOWN = DOWN;
  }
}

class Key {
  action: VIRTUAL_KEYBOARD_ACTIONS;
  component: JSX.Element;
  jump?: JumpPosition;
  spaces: number | number[];
  customAction?: () => void;

  constructor({
    action,
    component,
    jump,
    spaces,
    customAction,
  }: {
    action: VIRTUAL_KEYBOARD_ACTIONS;
    component: JSX.Element;
    jump?: JumpPosition;
    spaces: number | number[];
    customAction?: (data?: AutoComplete) => void;
  }) {
    this.action = action;
    this.component = component;
    this.jump = jump;
    this.spaces = spaces;
    this.customAction = customAction;
  }
}

export { JumpPosition };
export default Key;
